import typeToReducer from "type-to-reducer";
import update from 'immutability-helper';

import {
    LOAD_VIRTUAL_GAMES_LIST,
    SET_VIRTUAL_PROVIDER_LIST
} from "integrationActions.js";

let initialState = {
    gamesList: [],
    error: null,
    isPending: true,
    provider: null,
    singleGame: false,
    mustBeLogged: true,
    providerCreateIframe: false
};


export default typeToReducer({
    [SET_VIRTUAL_PROVIDER_LIST]: (state, {payload: {providerName, singleGame, mustBeLogged, providerCreateIframe}}) => {
        const newState  = update(
            state, 
            {provider: {$set: providerName},
            singleGame: {$set: singleGame},
            mustBeLogged: {$set: mustBeLogged},
            providerCreateIframe: {$set: providerCreateIframe}});
        return {...newState};
    },
    [LOAD_VIRTUAL_GAMES_LIST]: {
        PENDING: (state, action) => {
            return {...state, isPending: true}
        },
        FAILURE: (state, {payload: {error}}) => {
            return {...state, isPending: false, error};
        },
        SUCCESS: (state, {payload: {gamesList}}) => {
            return {...state, isPending: false, gamesList};
        }
    },
}, initialState);

